// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4577":"42eba192","9282":"dfa5131b"}[chunkId] + ".chunk.css";
};